import { GADimension } from '@ps/web-core-enums';
import produce from 'immer';

import { crmZone } from '../entities';
import { TrackingCategory } from '../enums';
import { type CrmZoneClick, crmZoneClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils/GAEvent';

import { crmEntity } from '.';

export const CRMClicked = (
  context: TrackingContextValue,
  zoneName: string,
  html: string,
  action: CrmZoneClick['action']
) => {
  const crmData = crmEntity(zoneName, html);

  if (crmData) {
    const { packageId, packageName } = crmData;

    GAEvent(
      { action: 'Zone Clicked', label: zoneName, value: packageId },
      { category: TrackingCategory.CRM },
      { [GADimension.UIElementName]: packageName }
    );

    crmZoneClick(
      { action },
      produce(context, (draft) => {
        draft.entities = draft.entities || [];
        draft.entities.push(crmZone({ zoneName }));
      })
    );
  }
};
